export const linkTheme = {
  button: {
    fontSize: 14,
    fontFamily: 'Avenir',
    fontWeight: 500,
  },
}
